import React from 'react';
import {Affix} from "antd";
import {TwitterOutlined,FacebookOutlined,InstagramOutlined,LinkedinOutlined} from '@ant-design/icons';
import logo from "../../assets/images/shecancode/logo.png";
const Footer = () => {

    return(
        <Affix >
     
        <div className="footer between-flex-column" style={{background:"#002b2b"}}>
        <div className="around-flex-row">
          <div className="title-section" style={{width:"30%"}}>
            <img src={logo} alt="logo" width="250" style={{marginTop:"-20px", borderRadius:"20px"}}/> <br/>
            <label className="title-lg">SheCanCode Materials</label>
            <p style={{marginTop:"20px"}}>This platform was created for purpose of helping Shecancode students, to have access on programming resources.</p>
           
          </div>
          <div>
              <ul className='list'>
                  <li className="list-items list-title">Quick links</li>
                  <li className="list-items"><a href="#">About us</a></li>
                  {/* <li className="list-items"> <a href="/auth/login">Login</a> </li> */}
                  <li className="list-items"><a href="#">Contact Us</a></li>
                  <li className="list-items"><a href="#">Terms of use</a></li>
              </ul>
          </div>
          <div>
              <ul className="list">
                  <li className="list-items list-title">Social links</li>
                  <li className="list-items"><a href="#"><TwitterOutlined style={{marginRight:"10px"}}/>  Twitter</a></li>
                  <li className="list-items"><a href="#"><FacebookOutlined style={{marginRight:"10px"}}/> Facebook</a></li>
                  <li className="list-items"><a href="#"><InstagramOutlined style={{marginRight:"10px"}}/> Instagram</a></li>
                  <li className="list-items"><a href="#"><LinkedinOutlined style={{marginRight:"10px"}}/> Linkedin</a></li>
              </ul>
          </div>
        </div>
        <div className='copyright'>
            <span> Copyright &copy; SheCanCode 2020 </span>
        </div>
      </div>       
        </Affix>
    )
}

export default Footer;
